/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_LocationInputs */



/**
* | output |
* | --- |
* | "Location" |
*
* @param {Profile_LocationInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const profile_location = /** @type {((inputs?: Profile_LocationInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_LocationInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Localisation")
	if (locale === "es") return /** @type {LocalizedString} */ ("Ubicación")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Localização")
	if (locale === "it") return /** @type {LocalizedString} */ ("Località")
	return /** @type {LocalizedString} */ ("Location")
});